// extracted by mini-css-extract-plugin
module.exports = {"SearchWrap":"SearchBar_SearchWrap__2i-Je","SearchIcon":"SearchBar_SearchIcon__1vq-x"};